module.exports = __webpack_public_path__ + "static/media/logohiddenbottomleft.2dcf1ea2.png";